import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";

export default function TermosPage() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-3xl mx-auto px-4 md:px-6 py-10">
        <h1 className="text-2xl md:text-3xl font-bold text-text">Termos de Uso</h1>
        <p className="text-sm text-gray-500 mt-1">Última atualização: 1º de junho de 2026 · Vigência a partir desta data.</p>

        <Secao n="1" titulo="Aceitação dos termos">
          Ao acessar ou usar o eaiRH ("plataforma"), você concorda com estes Termos de Uso e com a
          <Link to="/privacidade" className="text-primary font-semibold"> Política de Privacidade</Link>. Se não concordar,
          não utilize a plataforma.
        </Secao>

        <Secao n="2" titulo="O que é o eaiRH">
          O eaiRH é uma plataforma de <b>reputação de processos seletivos</b>. Candidatos compartilham relatos sobre
          como foram tratados por empresas em processos de recrutamento (incluindo casos de falta de retorno), e as
          empresas têm <b>direito de resposta</b>. O eaiRH atua como <b>intermediário tecnológico</b>: hospeda os relatos
          e disponibiliza ferramentas de interação e moderação. O eaiRH <b>não emite opinião</b> própria sobre as empresas.
        </Secao>

        <Secao n="3" titulo="Cadastro e conta">
          <ul className="list-disc pl-5 space-y-1">
            <li>Para publicar relatos é necessário ter uma conta. Você é responsável por manter a confidencialidade da sua senha.</li>
            <li>Você declara que as informações de cadastro são verdadeiras e atualizadas.</li>
            <li>É vedado criar contas falsas, em nome de terceiros, ou múltiplas contas para manipular reputações.</li>
          </ul>
        </Secao>

        <Secao n="4" titulo="Conteúdo publicado pelo usuário (relatos)">
          <ul className="list-disc pl-5 space-y-1">
            <li>Os relatos devem descrever <b>experiências reais e em primeira pessoa</b>, de boa-fé.</li>
            <li>Você é o <b>único responsável</b> pelo conteúdo que publica, inclusive por sua veracidade.</li>
            <li><b>É proibido</b>: conteúdo falso, difamatório, calunioso, discriminatório, ofensivo, ilegal, ou que
              exponha <b>dados pessoais de terceiros</b> (nome completo, telefone, e-mail de recrutadores, etc.).</li>
            <li>Mantenha o foco na <b>conduta da empresa no processo</b>, não em ataques pessoais a indivíduos.</li>
            <li>Você pode optar por publicar como <b>Anônimo</b> — seu nome não aparece publicamente, mas a conta
              permanece vinculada internamente para fins de moderação.</li>
          </ul>
        </Secao>

        <Secao n="5" titulo="Licença sobre o conteúdo">
          Ao publicar, você concede ao eaiRH uma licença não exclusiva e gratuita para hospedar, exibir e distribuir
          o seu relato na plataforma, com a finalidade de operá-la. Você continua titular do seu conteúdo e pode
          solicitar sua remoção a qualquer momento.
        </Secao>

        <Secao n="6" titulo="Moderação e direito de resposta">
          <ul className="list-disc pl-5 space-y-1">
            <li>O eaiRH pode <b>moderar, ocultar ou remover</b> conteúdo que viole estes Termos, mediante denúncia ou de ofício.</li>
            <li>Relatos reportados por múltiplos usuários podem ser <b>ocultados automaticamente</b> para análise.</li>
            <li>As <b>empresas têm direito de resposta</b> e podem contestar a veracidade de um relato, que será encaminhado à moderação.</li>
            <li>A reputação é calculada de forma automática a partir dos relatos e avaliações dos próprios usuários.</li>
          </ul>
        </Secao>

        <Secao n="7" titulo="Comunicação intermediada">
          Toda interação entre candidato e empresa acontece <b>dentro da plataforma</b>. O eaiRH não compartilha o
          contato direto de uma parte com a outra sem consentimento, permitindo a moderação do conteúdo.
        </Secao>

        <Secao n="7.1" titulo="Recursos de Inteligência Artificial">
          O eaiRH oferece recursos <b>opcionais</b> baseados em IA (ex.: leitura/pré-preenchimento de currículo e
          assistente virtual). Esses recursos são <b>meramente assistivos e informativos</b>: as sugestões podem conter
          imprecisões e devem ser <b>revisadas por você</b> antes de serem salvas ou utilizadas. As respostas do
          assistente <b>não constituem aconselhamento</b> jurídico, financeiro ou profissional. O uso é opcional e o
          tratamento de dados nesses recursos está descrito na <Link to="/privacidade" className="text-primary font-semibold">Política de Privacidade</Link>.
        </Secao>

        <Secao n="8" titulo="Isenção e limitação de responsabilidade">
          <ul className="list-disc pl-5 space-y-1">
            <li>O eaiRH <b>não se responsabiliza</b> pela veracidade dos relatos, que são de responsabilidade de quem os publica.</li>
            <li>O eaiRH não possui vínculo com as empresas mencionadas.</li>
            <li>A plataforma é fornecida "no estado em que se encontra", podendo eventualmente apresentar instabilidades.</li>
          </ul>
        </Secao>

        <Secao n="9" titulo="Suspensão e encerramento">
          O eaiRH pode suspender ou encerrar contas que violem estes Termos. Você pode encerrar sua conta e solicitar
          a exclusão dos seus dados a qualquer momento (ver Política de Privacidade).
        </Secao>

        <Secao n="10" titulo="Alterações dos Termos">
          Estes Termos podem ser atualizados. Mudanças relevantes serão comunicadas na plataforma. O uso continuado
          após alterações representa concordância.
        </Secao>

        <Secao n="11" titulo="Lei aplicável e foro">
          Estes Termos são regidos pelas leis da República Federativa do Brasil. Fica eleito o foro do domicílio do
          usuário para dirimir eventuais conflitos, conforme o Código de Defesa do Consumidor quando aplicável.
        </Secao>

        <Secao n="12" titulo="Contato">
          Dúvidas sobre estes Termos: <b>contato@eairh.com.br</b>.
        </Secao>

        <div className="mt-8 text-sm">
          <Link to="/privacidade" className="text-primary font-semibold hover:underline">Ver Política de Privacidade →</Link>
        </div>
      </main>
    </div>
  );
}

function Secao({ n, titulo, children }) {
  return (
    <section className="mt-6">
      <h2 className="text-lg font-bold text-gray-900">{n}. {titulo}</h2>
      <div className="mt-2 text-sm text-gray-700 leading-relaxed">{children}</div>
    </section>
  );
}
